// extracted by mini-css-extract-plugin
export default {"SystemStringDiv":"TableForEdit_SystemStringDiv__FYlhX","SystemStringInput":"TableForEdit_SystemStringInput__EWIEY"};